export default function formDataConstructor(textFields = {}, images = []) {
  console.log('[formDataConstructor] Constructing form data');
  var formData = new FormData();

  console.log('[formDataConstructor] Appending text fields:', textFields);
  Object.entries(textFields).forEach(entry =>
    formData.append(entry[0], entry[1])
  );

  console.log('[formDataConstructor] Appending image fields:', images);
  images.forEach(({ name, blob }, index) =>
    formData.append(`image-${index}`, blob, name)
  );

  return formData;
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/formDataConstructor.js